<template>
  <div class="coupons">
    <div class="head-box">
      <div class="c-flex c_flex_center">
        <h4>
          服务券
        </h4>
      </div>
      <div class="c-flex c-flex-item">
        <el-input
          placeholder="请输入服务券名称"
          v-model="searchValue"
          clearable
          @clear="
            fpi.page = 1;
            getData();
          "
          @keyup.enter.native="
            fpi.page = 1;
            getData();
          "
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="
              fpi.page = 1;
              getData();
            "
          ></el-button>
        </el-input>
        <el-button type="primary" @click="doNew" class="c-m-l-10">新增服务券</el-button>
        <el-button type="primary" @click="onShareClick" class="c-m-l-10">分享私密服务券</el-button>
        <el-popover width="200" popper-class="c-popper" @show="osg.colSetShow">
          <div
            v-if="osg.customize.entity.entityID == osg.customize.entity.tenantId"
            style="border-bottom: 1px solid #DCDFE6;margin-bottom: 12px;"
          >
            <div>
              <i class="el-icon-s-tools c-m-r-5"></i>
              <span>应用范围：</span>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-model="osg.customize.bizType"
                @change="osg.customizeBizTypeChange"
                placeholder="请选择"
                size="small"
                style="width:100%"
              >
                <el-option
                  v-for="item in osg.options.bizType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </div>
            <div style="margin:12px 0">
              <el-select
                v-if="osg.customize.bizType == 0"
                v-model="osg.customize.bizId"
                :remote-method="osg.getUsers"
                filterable
                remote
                placeholder="可搜索人员姓名/手机/组织"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.users"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
              <el-cascader
                v-if="osg.customize.bizType == 1"
                v-model="osg.customize.bizId"
                :options="osg.options.orgs"
                :props="{
                  checkStrictly: true,
                  emitPath: false,
                  label: 'orgName',
                  value: '_id',
                  children: 'orgList'
                }"
                size="small"
                style="width:100%"
                placeholder="请选择组织"
              ></el-cascader>
              <el-select
                v-if="osg.customize.bizType == 2"
                v-model="osg.customize.bizId"
                placeholder="请选择角色"
                size="small"
                style="width:100%"
                @change="$forceUpdate()"
              >
                <el-option
                  v-for="(item, i) in osg.options.roles"
                  :key="i"
                  :label="item.name"
                  :value="item._id"
                ></el-option>
              </el-select>
            </div>
          </div>
          <div class="c-popper-header">
            <i class="el-icon-info c-blue c-m-r-5"></i>
            <span>拖拽字段进行排序</span>
          </div>
          <div class="c-popper-content">
            <draggable v-model="extFields" @end="osg.listRefresh">
              <transition-group>
                <template v-for="(f, i) in extFields">
                  <div
                    v-if="f.showList && f.showList.indexOf('1') != -1"
                    :key="i"
                    class="c-popper-row"
                  >
                    <el-switch
                      v-model="f.customizeFlag"
                      :active-value="1"
                      :inactive-value="0"
                      @change="osg.listRefresh"
                    ></el-switch>
                    <span>{{ f.nameDisp }}</span>
                  </div>
                </template>
              </transition-group>
            </draggable>
          </div>
          <div class="c-popper-footer">
            <el-button type="primary" size="mini" @click="osg.saveConfig()">保存</el-button>
            <el-button type="text" size="mini" @click="osg.listReset">重置</el-button>
          </div>
          <i slot="reference" class="el-icon-s-operation c_size_20 c-blue c-m-l-10 c-pointer"></i>
        </el-popover>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table
          row-key="_id"
          ref="serviceVoucherData"
          height="calc(100% - 50px)"
          :data="fpi.data"
          highlight-current-row
          @selection-change="onSelectionChange"
          @header-dragend="osg.colWidthChange"
          border
        >
          <el-table-column
            type="selection"
            width="55"
            fixed
            :selectable="selectable"
            :reserve-selection="true"
          ></el-table-column>

          <c-table :fields="extFields">
            <template slot="scopeOrgIds">
              <el-table-column label="参与的服务商" width="180px" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{ scope.row.scopeOrgIds }}
                </template>
              </el-table-column>
            </template>
          </c-table>

          <el-table-column fixed="right" width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <el-button>
                  操作
                  <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    @click.native="
                      doRecord(scope.row._id);
                      openRecordDetail = true;
                    "
                  >
                    查看领取记录
                  </el-dropdown-item>
                  <el-dropdown-item
                    @click.native="
                      doEdit(scope.row);
                      openDetail = true;
                    "
                  >
                    编辑
                  </el-dropdown-item>
                  <el-dropdown-item @click.native="doStock(scope.row._id)">
                    修改最大发券数
                  </el-dropdown-item>

                  <el-dropdown-item
                    v-if="scope.row.state == 0"
                    @click.native="doEnable(scope.row._id)"
                  >
                    启用
                  </el-dropdown-item>

                  <el-dropdown-item
                    v-if="scope.row.state == 1"
                    @click.native="doDisable(scope.row._id)"
                  >
                    禁用
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>

        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination>
      </div>
    </div>

    <el-dialog title="服务券" :visible.sync="openDetail" width="800px">
      <c-form
        :formData="formData"
        :fields="extFields"
        :area="area"
        :options="options"
        @changeForm="osg.changeForm"
        ref="form"
        labelWidth="140px"
      >
        <template slot="scopeOrgIds">
          <el-cascader
            v-model="formData.scopeOrgIds"
            :options="supplierList"
            :props="{
              multiple: true,
              label: 'orgName',
              value: '_id',
              children: 'orgList',
              emitPath: false
            }"
            collapse-tags
          ></el-cascader>
        </template>
      </c-form>
      <div slot="footer">
        <el-button type="primary" @click="doSave">确 定</el-button>
        <el-button @click="doInit">取 消</el-button>
      </div>
    </el-dialog>

    <el-dialog title="服务券领取记录" :visible.sync="openRecordDetail" width="1000px">
      <div style="height: 100%; display: flex; flex-direction: column">
        <div style="height: 100%; display: flex; flex-direction: column">
          <div style="min-height: 400px; flex: 1">
            <div style="margin: 10px 0">
              <el-input
                placeholder="请输入服务券名称/手机号"
                style="width: 300px"
                v-model="searchRecordValue"
                clearable
                @clear="
                  recordFpi.page = 1;
                  doRecord(couponId);
                "
                @keyup.enter.native="
                  recordFpi.page = 1;
                  doRecord(couponId);
                "
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click="
                    fpi.page = 1;
                    doRecord(couponId);
                  "
                ></el-button>
              </el-input>
            </div>
            <el-table
              ref="recordTable"
              height="calc(100% - 80px)"
              :data="recordFpi.data"
              v-if="recordFpi.data && recordFpi.data.length && extFieldsCouponPrinting.length"
            >
              <c-table :fields="extFieldsCouponPrinting"></c-table>
            </el-table>
          </div>
        </div>
        <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="recordFpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="recordFpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="recordFpi.total"
        ></el-pagination>
      </div>
      <div slot="footer">
        <el-button
          type="primary"
          @click="
            openRecordDetail = false;
            couponId = '';
          "
        >
          关 闭
        </el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="分享私密服务券"
      :visible.sync="privateCoupon.openDetail"
      custom-class="privateCoupon-dialog"
      :destroy-on-close="true"
    >
      <div style="display:inline-block;text-align: left;">
        <div>已选中以下私密服务券：</div>
        <div v-for="(item, i) in selectedRows" :key="i">{{ i + 1 }}.{{ item.title }}</div>
      </div>
      <div
        class="qrcode c-flex c-flex-center"
        :id="'qrcode_' + privateCoupon.qrCodeKey"
        style="margin-top:20px"
        ref="qrCodeUrl"
      ></div>
      <div slot="footer">
        <el-button @click="privateCoupon.openDetail = false">
          关 闭
        </el-button>
        <el-button type="primary" @click="downloadCode">
          下载二维码
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2';
export default {
  activated() {
    window.$this = this;
  },
  name: 'serviceCouponDef',
  data() {
    window.$this = this;
    return {
      fpi: {
        page: 1,
        row: 20
      }, //分页和数据源
      extFields: [], //列表展示字段
      extFieldsCouponPrinting: [], //查询领取记录字段
      extField: {},
      rules: this.$util.rules,
      area: {
        options: this.osg.areaList,
        props: {
          checkStrictly: true,
          expandTrigger: 'hover'
        }
      },
      formData: {
        exts: {}
      }, //保存表单的时候要传递的数据
      options: {},
      searchValue: '', //输入框输入的值
      isEdit: false, //编辑为true,新增为false
      openDetail: false, //新增服务券 定义变量
      searchRecordValue: '', //查看服务卷领取记录弹窗 输入框输入的值
      openRecordDetail: false, //查看服务卷领取记录弹窗
      couponId: '', //用于查询服务券记录的服务券id
      recordFpi: {
        page: 1,
        row: 20
      }, //查询领取记录 分页和数据源
      supplierList: [], //表单中 参与服务商的字段
      selectedRows: [], //选中的表格
      privateCoupon: {
        openDetail: false,
        qrCodeKey: new Date() // 处理二维码下载缓存的问题
      }
    };
  },
  mounted() {
    // 请求服务券 表单 表头
    this.osg.getFields('serviceCouponDef', () => {
      this.osg.getFpi();
      this.getData();
      this.osg.getFields('serviceCoupon', () => {}, this, 'extFieldsCouponPrinting');
    });
    //获取组织信息
    this.getOrgs();
  },
  methods: {
    // 查询服务券接口
    getData() {
      var params = {
        page: this.fpi.page || 1,
        rows: this.fpi.rows || 20,
        'regex:title|string#or': this.searchValue,
        'regex:_id|string#or': this.searchValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.setFpi(params);
      this.osg.ajax('/basic/serviceCouponDef/query.do', params, res => {
        this.fpi = res;
        this.$nextTick(() => {
          if (this.$refs.serviceVoucherData) {
            this.$refs.serviceVoucherData.doLayout();
            this.$forceUpdate();
          }
        });
      });
    },
    //查看领取记录
    doRecord(couponId) {
      this.couponId = couponId;
      if (!couponId) return;
      var params = {
        page: this.recordFpi.page || 1,
        rows: this.recordFpi.rows || 20,
        'is:scdId|string#and': couponId,
        'regex:title|string#or': this.searchRecordValue,
        'regex:phone|string#or': this.searchRecordValue,
        'is:_id|string#or': this.searchRecordValue,
        sortField: 'createTime',
        sortOrder: 'desc'
      };
      this.osg.ajax('/basic/serviceCoupon/query.do', params, res => {
        this.recordFpi = res;
      });
    },
    // 新增服务券
    doNew() {
      this.isEdit = false;
      this.openDetail = true;
    },
    //新建服务券 保存操作
    doSave() {
      //处理一下时间
      if (this.formData.timeRange) {
        this.formData.startDate = this.formData.timeRange[0];
        this.formData.endDate = this.formData.timeRange[1];
        this.formData.exts.startDate = this.formData.startDate.substr(
          0,
          this.formData.startDate.indexOf(' ')
        );
        this.formData.exts.endDate = this.formData.endDate.substr(
          0,
          this.formData.endDate.indexOf(' ')
        );
        delete this.formData.timeRange;
      }
      if (this.formData.durationTimeRange) {
        this.formData.useStartDate = this.formData.durationTimeRange[0];
        this.formData.useEndDate = this.formData.durationTimeRange[1];
        this.formData.exts.useStartDate = this.formData.useStartDate.substr(
          0,
          this.formData.useStartDate.indexOf(' ')
        );
        this.formData.exts.useEndDate = this.formData.useEndDate.substr(
          0,
          this.formData.useEndDate.indexOf(' ')
        );
        delete this.formData.durationTimeRange;
      }
      // 调用函数
      let newObj = this.convertValuesToString(this.formData);
      console.log(newObj);
      this.osg.ajax('/basic/serviceCouponDef/upsert.do', { data: JSON.stringify(newObj) }, () => {
        this.doInit();
        this.getData();
        this.osg.toast('保存成功！');
      });
    },
    convertValuesToString(obj) {
      // 判断是否是对象和不是 null
      if (obj === null || typeof obj !== 'object') {
        return String(obj); // 直接返回字符串
      }
      // 创建一个新的对象或数组
      const newObj = Array.isArray(obj) ? [] : {};
      Object.keys(obj).forEach(key => {
        const value = obj[key];
        // 如果值是对象，递归调用
        if (typeof value === 'object' && value !== null) {
          newObj[key] = this.convertValuesToString(value); // 递归
        } else {
          // 直接转为字符串
          newObj[key] = String(value);
        }
      });
      return newObj; // 返回新的对象
    },
    //新建服务券  取消操作
    doInit() {
      // 关闭新增服务券弹窗
      this.openDetail = false;
      // 格式化数据结构
      this.formData = { exts: {} };
      // 重置表单状态
      if (this.$refs.formData) this.$refs.formData.resetFields();
    },
    //编辑单个服务券 接口
    doEdit(row) {
      this.couponId = row._id;
      if (!this.couponId) return;
      // 反显时间用
      if (row.startDate && row.endDate) {
        row.timeRange = [row.startDate, row.endDate];
      }
      if (row.useStartDate && row.useEndDate) {
        row.durationTimeRange = [row.useStartDate, row.useEndDate];
      }

      // 深拷贝一下 反显数据结构
      this.formData = this.$util.deepCopy(row);
    },
    //修改最大发券数
    doStock(id) {
      this.$prompt('请输入数字，正数加库存数量，负数将会减少库存数量', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^-?\d+$/,
        inputErrorMessage: '请输入整数',
        closeOnClickModal: false,
        closeOnPressEscape: false
      })
        .then(({ value }) => {
          this.osg.ajax('/basic/serviceCouponDef/adjustQuantity.do', { id, count: value }, () => {
            this.getData();
            this.osg.toast('操作成功！');
          });
        })
        .catch(() => {});
    },
    //修改服务券 状态
    doDisable(id) {
      this.osg.ajax('basic/serviceCouponDef/disable.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    //启用服务券状态
    doEnable(id) {
      this.osg.ajax('basic/serviceCouponDef/enable.do', { id }, () => {
        this.getData();
        this.osg.toast('操作成功！');
      });
    },
    //页码改变事件
    pageSizeChange(pageSize) {
      if (this.openRecordDetail) {
        this.recordFpi.rows = pageSize;
        this.doRecord(this.couponId);
      } else {
        this.fpi.rows = pageSize;
        this.getData();
      }
    },
    pageChange(currentPage) {
      if (this.openRecordDetail) {
        this.recordFpi.page = currentPage;
        this.doRecord(this.couponId);
      } else {
        this.fpi.page = currentPage;
        this.getData();
      }
    },
    onSelectionChange(rows) {
      this.selectedRows = rows;
    },
    //全选
    selectable(row) {
      if (row.scopeType == 99 && row.state == 1) {
        return true;
      } else {
        return false;
      }
    },
    //分享私密隐私券
    onShareClick() {
      if (this.selectedRows.length == 0) {
        this.osg.toast('请至少勾选1条私密服务券', 'warning');
        return;
      }
      this.queryLocationHost(baseUrl => {
        let privateCouponIds = this.selectedRows.map(item => item._id).join();
        console.log('privateCouponIds', privateCouponIds);

        this.privateCoupon.qrCodeKey = +new Date();
        console.log('this.privateCoupon.qrCodeKey', this.privateCoupon.qrCodeKey);
        this.privateCoupon.openDetail = true;
        this.$nextTick(() => {
          new QRCode(this.$refs.qrCodeUrl, {
            text: `${baseUrl}privateCoupon/?privateCouponIds=${privateCouponIds}`,
            width: 200,
            height: 200,
            colorDark: '#333333', //二维码颜色
            colorLight: '#ffffff', //二维码背景色
            correctLevel: QRCode.CorrectLevel.L //容错率，L/M/H
          });
        });
      });
    },
    //下载图片
    downloadCode() {
      const qrcode = document.querySelector(`#qrcode_${this.privateCoupon.qrCodeKey}`);
      const canvas = qrcode.querySelector('canvas');
      const imgurl = canvas.toDataURL('image/jpeg');
      const a = document.createElement('a');
      a.href = imgurl;
      a.download = '私密服务券二维码.png';
      a.click();
    },
    //基础（前缀）路径
    queryLocationHost(callback) {
      this.osg.ajax(
        'config/queryLocationHost.do',
        {},
        res => {
          if (callback) callback(res.data);
        },
        { noload: true }
      );
    },
    //获取一些组织数据
    getOrgs() {
      this.osg.ajax(
        'org/query.do',
        {
          notFilterOrgId: '1',
          sortField: 'order'
        },
        res => {
          this.removeEmptyorgList(res.data.orgList);
          this.supplierList = res.data.orgList;
          console.log('111', this.supplierList);
        }
      );
    },
    // 递归清理空的组织，orgList 属性
    removeEmptyorgList(orgList) {
      orgList.forEach(item => {
        // 判断是否有 orgList 属性
        if (item.orgList) {
          // 如果 orgList 是空数组，则删除该属性
          if (Array.isArray(item.orgList) && item.orgList.length === 0) {
            delete item.orgList;
          } else {
            // 如果 orgList 不是空数组，递归检查 orgList 内的每一项
            this.removeEmptyorgList(item.orgList);
          }
        }
      });
    }
  }
};
</script>
<style lang="scss">
.coupons {
  .privateCoupon-dialog {
    .el-dialog__body {
      text-align: center;
    }
  }
  .stockNum-view {
    width: 100%;
    .el-input__inner {
      border: none;
    }
  }
}
</style>
